export default __webpack_public_path__ + "static/media/header-back.8a1cdd5b.jpg";